import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { TransactionHistoryEventType } from './../transaction-history.event.type';
import { TweenMax, Quint } from 'gsap';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-transaction-result',
	templateUrl: './transaction-result.component.html',
	styleUrls: ['./transaction-result.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransactionResultComponent implements OnInit, OnDestroy {

	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private view = '[data-component="summary"]';
	public active: boolean;
	public success: boolean;
	public messages: string;

	constructor() { }

	ngOnInit() {
		this.addListeners();
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransactionHistoryEventType.HISTORY.TRANSACT_END);
	}

	private addListeners() {
		AppEventDispatcher.listen(TransactionHistoryEventType.HISTORY.TRANSACT_END, data => {
			if (data.show) {
				this.messages = data.messages;
				this.success = data.success;
				this.active = true;
				this.show();

				this.showStepButtons.emit(true);
			}
		});
	}

	private show() {
		const interval = setInterval(() => {
			if ($(this.view).length > 0) {
				TweenMax.to(this.view, .8, {left: 0, ease: Quint.easeOut});
				clearInterval(interval);
			}
		}, 10);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transaction-history/transaction-result/transaction-result.component.ts